var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { memo, createRef, useEffect, useState } from 'react';
import L from 'leaflet';
import { MapContainer, TileLayer, Marker, Tooltip, useMap } from 'react-leaflet';
import { usePrevious } from '../utils/helpers';
var markerRefs = [];
var Post = memo(function (props) {
    var place = props.place, iconClass = props.iconClass;
    var newRef = createRef();
    markerRefs.push(newRef);
    return (_jsx(Marker, __assign({ position: [place.lat, place.lon], 
        // eventHandlers={{ click: () => showPreview(place) }}
        icon: L.divIcon({
            iconSize: [40, 40],
            iconAnchor: [20, 20],
            popupAnchor: [0, 0],
            shadowSize: [0, 0],
            className: "map_icon ".concat(iconClass),
        }), ref: newRef }, { children: _jsx(Tooltip, { children: place.display_name }) }), place.place_id));
});
export default React.memo(function (props) {
    var coords = props.coords, wikiMapCenter = props.wikiMapCenter, wikicoords = props.wikicoords, setGeoResultsI = props.setGeoResultsI, paintingPage = props.paintingPage;
    var _a = useState(0), page = _a[0], setPage = _a[1];
    var _b = useState({}), mapCenter = _b[0], setMapCenter = _b[1];
    var prevPage = usePrevious(page);
    var prevPaintingPage = usePrevious(paintingPage);
    var defaultPosition = [38.65727, -90.29789];
    var renderItems = function (coords, icon) {
        return coords &&
            coords.map(function (place) { return (_jsx(Post, { iconClass: "map_icon__".concat(icon), place: place }, place.place_id)); });
    };
    function RecenterAutomatically(props) {
        var lat = props.lat, lon = props.lon;
        var map = useMap();
        useEffect(function () {
            map.setView([lat, lon]);
        }, [lat, lon, map]);
        return null;
    }
    useEffect(function () {
        if (wikiMapCenter && wikiMapCenter.lat) {
            setMapCenter(wikiMapCenter);
        }
    }, [wikiMapCenter]);
    useEffect(function () {
        if (prevPaintingPage !== paintingPage) {
            setPage(0);
        }
    }, [paintingPage, prevPaintingPage]);
    useEffect(function () {
        if (page > -1 && prevPage !== page) {
            setGeoResultsI(page);
        }
    }, [page, prevPage, setGeoResultsI]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "map__container__key" }, { children: [_jsx("div", { className: "map_icon map_icon__painting" }), _jsx("div", __assign({ className: "key__label" }, { children: "Address" })), _jsx("div", { className: "map_icon map_icon__wiki" }), _jsx("div", __assign({ className: "key__label" }, { children: "Article" }))] })), (coords && coords.length > 0) ||
                (wikicoords && wikicoords.length > 0) ? (_jsxs("div", __assign({ className: "map__container" }, { children: [_jsxs(MapContainer, __assign({ center: defaultPosition, zoom: 15, scrollWheelZoom: false, style: { height: '100%', minHeight: '100%', width: '100%' } }, { children: [_jsx(TileLayer, { attribution: ' Map data <br /> \u00A9 <a href="https://www.openstreetmap.org/">OpenStreetMap</a>,<br /> <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>,<br />  Imagery \u00A9 <a href="https://www.mapbox.com/">Mapbox</a>', url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" }), coords &&
                                coords.length > 0 &&
                                renderItems(coords, 'painting') /** coordinates from geo search */, wikicoords &&
                                wikicoords.length > 0 &&
                                renderItems(wikicoords, 'wiki') /** coordinates from wiki articles */, mapCenter.lat && mapCenter.lon && (_jsx(RecenterAutomatically, { lat: mapCenter.lat, lon: mapCenter.lon }))] })), _jsx("div", __assign({ className: "map__paging_wrap" }, { children: _jsxs("div", __assign({ className: "map__paging page" }, { children: [page + 1, " of ", coords.length, _jsx("br", {}), _jsx("button", __assign({ type: "button", className: "prev", onClick: function () { return setPage(page - 1); }, disabled: page === 0 }, { children: "previous" })), ' ', "|", ' ', _jsx("button", __assign({ type: "button", className: "next", onClick: function () { return setPage(page + 1); }, disabled: page === coords.length - 1 }, { children: "next" }))] })) }))] }))) : (_jsx("div", { children: _jsx("div", __assign({ className: "render-coontainer" }, { children: _jsx("div", __assign({ className: "painting flx-ctr fadein" }, { children: _jsx("svg", __assign({ className: "loading", viewBox: "25 25 50 50" }, { children: _jsx("circle", { cx: "50", cy: "50", r: "20" }) })) })) })) }))] }));
});
